import { StaticInterface } from '../../../helpers/static-interface';

export interface ITpxFilterMenuUtils {
  close(): void;
  open(): void;
}

export interface IStaticTpxFilterMenuUtils {
  new(...args: any[]): ITpxFilterMenuUtils;
  init(scope?: HTMLElement): void;
}

/**
 * Filter menu functionality
 * @class
 */
export default class TpxFilterMenuUtils implements StaticInterface<IStaticTpxFilterMenuUtils, typeof TpxFilterMenuUtils> {
  #element: HTMLElement;

  /**
   * @constructor
   * @param {HTMLElement} element The list root element
   */
  constructor(element: HTMLElement) {
    this.#element = element;
  }

  close() {
    this.#element?.classList.remove('m-filter-menu--opened');
  }

  handleKeyUp(evt?: KeyboardEvent) {
    if (evt?.key === 'Escape') {
      this.close();
    }
    else {
      document.addEventListener('keyup', evt => this.handleKeyUp(evt), {
        once: true,
      });
    }
  }

  open() {
    this.#element?.classList.add('m-filter-menu--opened');
    this.handleKeyUp();
  }

  /**
   * Creates new instances of TpxFilterMenuUtils for each `.m-filter-menu` element,
   * and adds the necessary event listeners to support opening and closing of the filter menu.
   */
  static init(scope?: HTMLElement) {
    const filterMenus: Element[] = [...(scope || document).getElementsByClassName('m-filter-menu')];
    filterMenus.forEach(filterMenu => {
      const filterMenuUtil = new TpxFilterMenuUtils(filterMenu as HTMLElement);

      filterMenu.querySelector('.m-filter-menu__close')?.addEventListener('click', () => {
        filterMenuUtil.close();
      });

      filterMenu.querySelector('.m-filter-menu__open')?.addEventListener('click', () => {
        filterMenuUtil.open();
      });
    });
  }
}